
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planifier",
      function () {
        return require("private-next-pages/planifier/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planifier"])
      });
    }
  